var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.Visible)?_c('div',{staticClass:"message_warpper",class:_vm.Type,style:('transform: translate(-50%,'+parseFloat(_vm.informCount*150-200)+'%);')},[_vm._v(_vm._s(_vm.Message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }